import { validUrl } from '@/composables/validUrl';
import store from '@/store'

export function addLinksToText(text) {
    // detect emoji
    const regexExpEmoji = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
    if (regexExpEmoji.test(text) && text.length <= 4) {
        //console.log(text.length, 'found  emoji');
        return '<span style="font-size:3.0em;">' + text + '</span>';
    }
    if(text.length>15000){
        return text;
    }
    /* NOTE: we are having issues with these xhtml br tags */
    let cleanedText = text.replace(/ \/>/gi, '>');
    cleanedText = cleanedText.replace(/(<([^>]+)>)/gi, " ");
    cleanedText = cleanedText.replace(/\n/gi, ' ');
    cleanedText = cleanedText.replace(/\t/gi, ' ');
    cleanedText = cleanedText.replace(/\s/gi, ' ');
    var tokens = cleanedText.split(/\s/);
    var updatedText = text;
    //console.log(cleanedText, 'updated text');
    for (var i = 0; i < tokens.length; i++) {
        var word = tokens[i].trim();
        //console.log('word found: ' + word);
        var newWord = tokens[i];
        var firstChar = tokens[i].substring(0, 1);
        if (firstChar == "#") {
            // console.log('hashtag found: ' + tokens[i]);
            var hashtag = word.replace(/[^\w\s]|_/g, "");
            newWord = '<a href="search/' + hashtag + '">' + word.trim() + '</a>';
        } else if (firstChar == "@") {
            // console.log('user found: ' + tokens[i]);
            //var username = word.replace(/[^\w\s]|_/g, "");
            var username = word.replace(/[^\w\-]/g, "");
            newWord = '<a href="u/' + username + '">' + word.trim() + '</a>';
        } else if (validUrl(word)) {
            var preText = '';
            if (word.substring(0, 4) != "http") preText = "https://";
            //console.log(word, 'url');
            //console.log(newWord, 'url to replace');
            newWord = '<a href="' + preText + word.trim() + '" target="_blank">' + word.trim() + '</a>';
        }
        updatedText = updatedText.replace(word, newWord);
        // updatedText = updatedText + word + ' ';
    }
    //updatedText = updatedText.replace(/\n/gi, '<br>');
    return updatedText;
}


export function checkForUsers(text) {
    let userSuggest = false;
    var splitString = text.split(' ');
    //console.log('checking for usernames ' + splitString.length);
    for (var i = 0; i < splitString.length; i++) {
        if (i == splitString.length - 1) {
            if (splitString[i].substring(0, 1) == "@") {
                if (splitString[i].length > 3) {
                    userSuggest = true;
                    let cleanString = splitString[i].replace('@', '');
                    store.dispatch("helpers/usernameSearch", {
                        search: cleanString,
                    });
                    //this.displayUsers(splitString[i]);
                }
            } else {
                userSuggest = false;
            }
        }
    }
    return userSuggest;
}

export function  getHostName(url) {
    var match = '';
    if (url != '' && url != undefined) {
        match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    }
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
    } else {
        return null;
    }
}

export function checkForHashtags(text) {
    var splitString = text.split(' ');
    let hashtagSuggest = false
    // console.log('checking for usernames ' + splitString.length);
    for (var i = 0; i < splitString.length; i++) {
        if (i == splitString.length - 1) {
            if (splitString[i].substring(0, 1) == "#") {
                if (splitString[i].length > 3) {
                    hashtagSuggest = true;
                    let cleanString = splitString[i].replace('#', '');
                    store.dispatch("helpers/hashtagSearch", {
                        search: cleanString,
                    });
                    //this.displayHashtags(splitString[i]);
                }
            } else {
                hashtagSuggest = false;
            }
        }
    }
    return hashtagSuggest;
}

export function checkForLinks(text, linkPreviews) {
    //const last = text.at(-1);
    let splitString = text.split(/(\s+)/);
    var checkForLinks = false;
    var linkForPreview = '';
    let loadingLink = false;
    let retryLink = false;
    // console.log('checking for usernames ' + splitString.length);
    for (var i = 0; i < splitString.length; i++) {
        if (validUrl(splitString[i])) {
            //console.log(splitString[i],'valid url');
            checkForLinks = true;
            linkForPreview = splitString[i];
        }
    }
    if (checkForLinks && linkPreviews==undefined) {
        // set loading here
        loadingLink = true;
        if(store.state.helpers.linkData!=undefined){
            retryLink = true;
        }
        store.dispatch("helpers/linkPreview", {
            link_url: linkForPreview,
            retryLink: retryLink
        });
        //this.displayLinkData(linkForPreview);
    }else if(linkPreviews!=undefined && linkPreviews.link_url != linkForPreview){
        loadingLink = true;
        if(store.state.helpers.linkData!=undefined){
            retryLink = true;
        }

        store.dispatch("helpers/linkPreview", {
            link_url: linkForPreview,
            retryLink: retryLink
        });
    }
    return loadingLink;
}

export function updateUsername(usernameString, textString) {
    var splitString = textString.split(' ');
    let lastWord = splitString[splitString.length - 1];
    textString = textString.replace(lastWord, '@' + usernameString + ' ');
    //console.log(textString);
}

export function updateHashtag(hashtagString, textString) {
    //console.log('selected: ' + hashtagString);
    var splitString = textString.split(' ');
    let lastWord = splitString[splitString.length - 1];
    textString = textString.replace(lastWord, hashtagString + ' ');
    //console.log(textString);
}
